import { render, staticRenderFns } from "./VatTable.vue?vue&type=template&id=0a0a160a&"
import script from "./VatTable.vue?vue&type=script&lang=js&"
export * from "./VatTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports